import React, { useState } from "react";
import seven_slider from '../../assets/seven_slider.avif';

const pricingOptions = [
  { label: 'Старт', price: 59, display: 'от 59 $ / месяц' },
  { label: 'Бизнес', price: 49.66, display: 'от 49.66 $ / месяц' },
  { label: 'Корпоративный', price: 33.25, display: 'от 33.25 $ / месяц' },
];

const SubscriptionBlock = () => {
  const [selectedOption, setSelectedOption] = useState(0);

  const totalPrice = () => {
    if (selectedOption === 1) return `${(49.66 * 3).toFixed(2)} $`;
    if (selectedOption === 2) return `${(33.25 * 12).toFixed(2)} $`;
    return `${pricingOptions[selectedOption].price} $`;
  };

  return (
    <section className="bg-bg pb-14 font-[Inter,Manrope,Arial,sans-serif] text-content">
      <div className="mx-auto max-w-[1240px] px-4">
        
        {/* Шапка блока */}
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4 border-b border-line pb-4">
          <div>
            <div className="mb-1 text-[10px] font-normal uppercase tracking-[.2em] text-accent">
              Сотрудничество
            </div>
            <h2 className="text-2xl font-light tracking-tight text-content sm:text-3xl">
              Начните работать с нами
            </h2>
          </div>
        </div>

        {/* Основной контейнер-карточка */}
        <div className="overflow-hidden rounded-2xl border border-line-strong bg-surface shadow-[0_10px_30px_rgba(0,0,0,0.03)] flex flex-col lg:flex-row items-stretch">
          
          {/* Левая часть: Картинка */}
          <div className="w-full lg:w-1/2 overflow-hidden bg-bg">
            <img
              src={seven_slider}
              alt="Сотрудничество"
              className="h-full w-full object-cover min-h-[320px]"
            />
          </div>

          {/* Правая часть: Форма выбора тарифа */}
          <div className="w-full lg:w-1/2 p-6 sm:p-10 flex flex-col justify-between bg-surface">
            <div>
              <h3 className="text-xl font-light tracking-tight text-content mb-6 leading-snug">
                Выберите подходящий формат и получите первые результаты
              </h3>

              <div className="flex flex-col gap-3 mb-6">
                {pricingOptions.map((option, index) => (
                  <div
                    key={index}
                    onClick={() => setSelectedOption(index)}
                    className={`cursor-pointer flex items-center gap-4 rounded-xl border px-4 py-3.5 transition-all ${
                      selectedOption === index
                        ? 'border-accent bg-accent-soft'
                        : 'border-line-strong bg-surface hover:border-line-strong'
                    }`}
                  >
                    {/* Кастомный радио-индикатор */}
                    <div className={`w-4 h-4 rounded-full border flex items-center justify-center transition-colors ${
                      selectedOption === index ? 'border-accent' : 'border-line-strong'
                    }`}>
                      {selectedOption === index && (
                        <div className="w-2 h-2 bg-accent rounded-full"></div>
                      )}
                    </div>
                    
                    <div className="text-left flex-1">
                      <div className="text-xs font-medium text-content">
                        {option.label}
                      </div>
                      <div className="text-[11px] font-light text-muted">
                        {option.display}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <button className="shine w-full py-3.5 rounded-xl bg-accent text-white text-xs font-medium transition hover:bg-accent-hover shadow-sm">
                Начать сотрудничество за {totalPrice()}
              </button>
            </div>

            <p className="mt-6 text-[10px] font-light text-subtle text-center lg:text-left">
              Первая консультация бесплатно. Цены указаны в долларах США.
            </p>
          </div>

        </div>

      </div>
    </section>
  );
};

export default SubscriptionBlock;